const META_PIXEL_ID = String(process.env.REACT_APP_META_PIXEL_ID || '').trim()

const META_PIXEL_SCRIPT_ID = 'meta-pixel-script'

function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}

function isValidPixelId(pixelId) {
  return /^[0-9]+$/.test(String(pixelId || '').trim())
}

export function getMetaPixelId() {
  return META_PIXEL_ID
}

export function isMetaPixelConfigured() {
  return isValidPixelId(META_PIXEL_ID)
}

export function initializeMetaPixel() {
  if (!isBrowser() || !isMetaPixelConfigured()) {
    return false
  }

  if (window.__SOS_META_PIXEL_INITIALIZED__) {
    return true
  }

  /* eslint-disable */
  if (!window.fbq) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = true
      t.src = v
      t.id = META_PIXEL_SCRIPT_ID
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  }
  /* eslint-enable */

  window.fbq('init', META_PIXEL_ID)
  window.__SOS_META_PIXEL_INITIALIZED__ = true
  return true
}

export function trackCompleteRegistration() {
  if (!isBrowser() || !initializeMetaPixel() || typeof window.fbq !== 'function') {
    return false
  }

  window.fbq('track', 'CompleteRegistration')
  return true
}
